import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiClientService } from '../../../core/http/api-client.service';
import {
  NotificationQueueFilters,
  NotificationQueuePage,
  NotificationQueuePageDto,
  NotificationQueueSort,
} from './notification-queue.models';
import { mapNotificationQueueItem } from './notification-queue.mapper';

@Injectable({
  providedIn: 'root'
})
export class NotificationQueueService
{
  private readonly apiClient = inject(ApiClientService);

  public getPage(
    params: {
      limit: number;
      cursor?: string | null;
      filters?: NotificationQueueFilters;
      sort?: NotificationQueueSort;
    },
  ): Observable<NotificationQueuePage>
  {
    const query = {
      status: params.filters?.status,
      eventType: params.filters?.eventType,
      entityType: params.filters?.entityType,
      clientId: params.filters?.clientId,
      sort: params.sort,
      limit: params.limit,
      cursor: params.cursor ?? undefined,
    };

    return this.apiClient.get<NotificationQueuePageDto>(
      '/notification-queue',
      query,
    ).pipe(
      map((dto) => ({
        items: Array.isArray(dto?.items) ? dto.items.map(mapNotificationQueueItem) : [],
        nextCursor: dto?.nextCursor ?? null,
        hasMore: !!dto?.hasMore,
      })),
    );
  }
}
